import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IAppointmentsDataType {
  consultingSlot: string;
  createdAt: string;
  createdBy: string;
  endDateTime: string;
  firstName: string;
  id: string;
  lastName: string;
  patientId: string;
  startDateTime: string;
  status: string;
  type: string;
  updatedAt: string;
  updatedBy: string;
}

interface AppointmentsState {
  appointmentsData: IAppointmentsDataType[];
}

const initialState: AppointmentsState = {
  appointmentsData: [],
};

const appointmentsSlice = createSlice({
  name: "appointments",
  initialState,
  reducers: {
    setAppointmentsData(state, action: PayloadAction<IAppointmentsDataType[]>) {
      state.appointmentsData = action.payload;
    },
    clearAppointmentsData(state) {
      state.appointmentsData = [];
    },
  },
});

export const { setAppointmentsData, clearAppointmentsData } =
  appointmentsSlice.actions;
export default appointmentsSlice.reducer;
